import React from 'react';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import Money from '@components/Gui/Money';
import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables.js';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    margin-bottom: 0.5rem;
    border-radius: 6px;
    background: #fff;
    display: flex;
    flex-direction: row;
    cursor: ${(props) => (props.$pointercursor ? 'pointer' : 'not-allowed')};
    user-select: none;
    border-bottom: ${(props) => props.theme.DefaultBorder};
    margin: 0.25rem 0.5rem;

    &:last-child {
        border-bottom: none;
    }

    .invoice-number {
        width: 6rem;
        font-weight: bold;
        font-size: 1rem;
        text-align: center;
        padding-top: 0.75rem;
    }

    .credit-note-number {
        width: 6rem;
        font-weight: bold;
        font-size: 1rem;
        text-align: center;
        padding-top: 0.25rem;
        color: ${(props) => props.theme.DangerColor};
    }

    .invoice-detail {
        padding: 0.25rem 0.5rem;
        flex: 1 1 0;
        border-right: ${StyleVariables.DarkerBorder};

        .invoice-date {
            font-size: ${(props) => props.theme.FontSizeSm};
        }

        small {
            font-style: italic;
            opacity: 0.75;
            display: block;
        }
    }
    .invoice-totals {
        width: 10rem;
        padding: 0.25rem 0.5rem;
        text-align: right;

        span.title-span {
            text-transform: uppercase;
            font-size: ${(props) => props.theme.FontSizeSm};
            display: block;
        }
        span.money-span {
            font-weight: bold;
            display: block;
        }
    }
`;

const InvoiceItem = ({ invoice, onInvoiceClick, hasAccountingAccess }) => {
    const handleInvoiceClick = () => {
        onInvoiceClick(invoice.ID);
    };

    const isCreditNote = invoice.TypeName.includes('Credit');

    return (
        <Wrapper onClick={handleInvoiceClick} $pointercursor={hasAccountingAccess}>
            {isCreditNote ? (
                <div className="credit-note-number">
                    {invoice.Number ? invoice.Number : <NwIcon icon={byPrefixAndName.fasl['empty-set']} />}
                    <br />
                    <NwIcon icon={byPrefixAndName.fasl['rotate-reverse']} />
                </div>
            ) : (
                <div className="invoice-number">
                    {invoice.Number ? invoice.Number : <NwIcon icon={byPrefixAndName.fasl['empty-set']} />}
                </div>
            )}
            <div className="invoice-detail">
                <div className="contact-info">
                    {getContactName(invoice.ContactID).toUpperCase()} / {invoice.BillingInfo.CompanyName}
                </div>
                <small>{invoice.Name}</small>
                <div className="invoice-date">
                    {invoice.Date ? getMoment(invoice.Date).format('DD MMM YYYY') : 'N.D'}
                </div>
            </div>
            <div className="invoice-totals">
                <span className="title-span">Total Amount</span>
                <Money
                    amounts={[invoice.TotalAmount, invoice.TotalTaxes, invoice.TotalVat]}
                    currency={invoice.Currency}
                />
            </div>
        </Wrapper>
    );
};

export default InvoiceItem;
